import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";
import RegisterCard from "../cards/RegisterCard";
import { ModelContext } from "../../contexts/ModelContextProvider";
import styles from "./RegisterModal.module.css";

function RegisterModal() {
  const { isOpen, setClose } = useContext(ModelContext);
  return (
    <Modal
      className={` ${styles.modalContainer}`}
      show={isOpen}
      onHide={setClose}
      style={{
        maxHeight: "95vh",
        overflowY: "auto",
        scrollbarWidth: "none",
        padding: "0px",
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <RegisterCard />
    </Modal>
  );
}

export default RegisterModal;
